import{_ as a}from"./_nativeCreate.js";var t=a;var _=function(){this.__data__=t?t(null):{},this.size=0};export{_};
